import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/article/gtbuy-spreadsheet-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/gtbuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;